export default "__VITE_ASSET__efef3c67__"